/* eslint-disable no-useless-escape */
import type { FC } from 'react'
import React from 'react'
import type { Theme } from '@material-ui/core/styles'
import { makeStyles, createStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import type { ActivityLogType } from '@homeviews/models'
import { useGetLogsQuery } from '@homeviews/store'
import Card from '../Card'
import Typography from '../Typography'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    inner: {
      overflowY: 'auto',
      maxHeight: 250,
    },
    card: {},
    item: {
      display: 'flex',
      alignItems: 'flex-start',
      '& + &': {
        marginTop: 24,
      },
    },
    iconWrapper: {
      width: 27,
      height: 27,
      borderRadius: '50%',
      marginRight: 12,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
    },
    icon: {},
    date: {
      color: theme.colors.grey450,
      fontSize: theme.typography.pxToRem(10),
      fontWeight: 400,
      letterSpacing: '-0.17px',
      lineHeight: theme.typography.pxToRem(13),
      margin: '3px 0 0 0',
    },
    content: {},
    title: {
      color: '#636B76',
      fontSize: theme.typography.pxToRem(12),
      fontWeight: 400,
      letterSpacing: '-0.2px',
      lineHeight: theme.typography.pxToRem(15),
      margin: 0,
      '& span': {
        color: theme.colors.grey800,
      },
    },
  }),
)

const RECORD_MAPPING = {
  AppEventsCompanyProfileUpdatedEvent: {
    icon: 'assets/icons/small/upload.svg',
    color: '#00DEB6',
  },
  AppEventsCompanyEditSubmittedEvent: {
    icon: 'assets/icons/small/edit.svg',
    color: '#4E516B',
  },
  AppEventsCompanyEditRejectedEvent: {
    icon: 'assets/icons/small/close.svg',
    color: '#C22A2E',
  },
  AppEventsDevelopmentEditRejectedEvent: {
    icon: 'assets/icons/small/close.svg',
    color: '#C22A2E',
  },
  AppEventsDevelopmentProfileUpdatedEvent: {
    icon: 'assets/icons/small/upload.svg',
    color: '#00DEB6',
  },
  AppEventsReplyPublishedEvent: {
    icon: 'assets/icons/small/upload.svg',
    color: '#00DEB6',
  },
  AppEventsReplyRejectedEvent: {
    icon: 'assets/icons/small/close.svg',
    color: '#C22A2E',
  },
}
interface IProps {
  recordType: 'review' | 'company' | 'development'
  className?: string
}

const ActivityLog: FC<IProps> = ({ className, recordType }) => {
  const classes = useStyles()

  const { data } = useGetLogsQuery({
    filter: recordType,
  })

  const normalizeKey = (text: string) => text.replace(/\\/g, '')

  if (!data?.data?.length) {
    return null
  }

  return (
    <div className={clsx(classes.root, className && className)}>
      <Card
        className={clsx(classes.card)}
        header={<Typography variant="h3">Activity log</Typography>}
      >
        <div className={classes.inner}>
          {data.data.map((record: ActivityLogType, index: number) => {
            //
            return (
              <div className={classes.item} key={`${index}-${record.message}`}>
                <div
                  className={classes.iconWrapper}
                  style={{ backgroundColor: '#4E516B' }}
                >
                  <img
                    alt="Activity Log Icon"
                    src={`${
                      RECORD_MAPPING?.[normalizeKey(record.type)]?.['icon'] ||
                      'assets/icons/small/edit.svg'
                    }`}
                  />
                </div>
                <div className={classes.content}>
                  <Typography className={classes.title}>
                    {record.message}
                  </Typography>
                  <Typography className={classes.date}>
                    {record.created_at}
                  </Typography>
                </div>
              </div>
            )
          })}
        </div>
      </Card>
    </div>
  )
}

export default ActivityLog
